module.exports = __webpack_public_path__ + "img/ZG81_18.25c45110.jpg";